import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsBuyPackageModalLoading } from '../../../../selectors/buyPackageModal';
import { trackNotEnoughMoneyPopupOpen, trackGoToPay } from './tracking';
import { NotEnoughMoney } from './NotEnoughMoney';
import { Button } from '@cian/ui-kit';

export const NotEnoughMoneyContainer = () => {
  const isLoading = useSelector(selectIsBuyPackageModalLoading);

  React.useEffect(() => {
    trackNotEnoughMoneyPopupOpen();
  }, []);

  const handleClick = React.useCallback(() => {
    trackGoToPay();

    window.location.assign('https://my.cian.ru/pay');
  }, []);

  const depositButton = (
    <Button onClick={handleClick} fullWidth loading={isLoading}>
      Пополнить счёт
    </Button>
  );

  return <NotEnoughMoney button={depositButton} />;
};
